<template>
  <section>
    <Header :indexData="indexData" :userInfo="userInfo" :keyword="keyword"></Header>
    <div class="container">
      <div class="help-menu">
        <div class="product-side">
          <!-- <div class="product-title" style="border:none"> -->
            <h2 style="width:200px;box-sizing:border-box" class="center color-primary">推荐商品</h2>
          <!-- </div> -->
          <div class="liulanjilu" style="margin-top:20px">
            <ul class="clearlist">
              <li v-for="(item,index) in CanAgincan.data" :key="index">
                <a :href="'#/goodsdetail?id='+item.id" target="_blank">
                  <div class="img">
                    <img :src="item.indexpic" />
                  </div>
                  <div class="name">{{item.title}}</div>
                  <div class="price">￥{{item.price}}</div>
                </a>
              </li>
            </ul>
          </div>
        </div>
        
      </div>
      <div class="help-main">
        <div class="help-tit">{{content.title}}</div>
        <div class="content mt10 text-right color-primary">发布时间:{{content.addtime}} &nbsp;&nbsp;&nbsp;&nbsp;作者:{{content.author}}</div>
        <div class="help-cont" v-html="content.content"></div>
        <div class="content mt10  mb10 text-center" v-if="content.keywords.length>0"> <span class="bold" style="font-size:18px">关键词:</span> &nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; 
          <span style="margin-right:20px;font-size:17px" v-for="(item,index) in content.keywords" :key='index'>{{item}}</span>
        </div>
        <el-pagination
          class="fenye"
          background
          layout="prev, pager, next"
          :page-size="1"
          @current-change="currentorder"
          :total="list.total"
        ></el-pagination>
      </div>
    </div>
    <Footer :indexData="indexData"></Footer>
  </section>
</template>

<script>
import Header from "../components/header";
import Footer from "../components/footer";
export default {
  components: {
    Header,
    Footer
  },
  name: "Newslist",
  data() {
    return {
      guid: "",
      CanAgincan: {},
      indexData: {
        index_cartnum: 0,
        index_shop_self: {
          adlist: [{ url: "", src: "" }, { url: "", src: "" }]
        }
      },
      userInfo: {},
      keyword: "",
      id: getParameterByName("id"),
      detailid: getParameterByName("detailid"),
      content: {keywords:[]},
      list: {}
    };
  },
  watch: {
    detailid() {
      this.getcontentInfo();
    }
  },
  methods: {
    changeId(detailid) {
      this.detailid = detailid;
    },
    currentorder(e) {
      console.log(this.list.data[e - 1]);
      this.detailid = this.list.data[e - 1].id;
    },
    // 获取列表
    async getCanAgincan() {
      this.CanAgincan = await this.$fetch("Shop/productlist", {
        body: {
          isresume: 1,
          page: 1,
          size: 5,
          sort: 1,
          categoryid: 57
        }
      });
    },
    // 获取内容区域
    async getcontentInfo() {
      let content = await this.$fetch("index/detail", {
        body: {
          type: "content_news",
          id: this.detailid ? this.detailid : this.list.data[0].id
        }
      });
      content.keywords=content.keywords?content.keywords.split(","):[];
      this.content=content;
      console.log("this.content",this.content)
    },
    // 获取列表
    async getlist() {
      let res = await this.$fetch("index/content", {
        body: {
          type: "content_news",
          pid: this.id,
          pagesize: 30
        }
      });
      this.list = res;
      console.log(this.list);
    }
  },

  async mounted() {
    this.guid = sessionStorage.guid;
    if (sessionStorage.user) {
      this.userInfo = JSON.parse(sessionStorage.user);
    }
    await this.getlist();
    
    this.indexData = await this.$fetch("Index/indexdata");
    this.getcontentInfo();
    this.getCanAgincan();

  }
};
</script>


<style lang='scss' scoped>
.container {
  .help-main {
    width: 850px;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/newschd.vue